import * as React from 'react';

/**
 * This component marks PII.
 * The fs-exclude class is for FullStory to mask PII when user recordings are played.
 */
export const PersonallyIdentifiableInfo = ({
  component: Component = 'span',
  children,
}: React.PropsWithChildren<{
  component?: 'div' | 'span';
  skeletonWidth?: number | string;
}>) => {
  return <Component className="fs-exclude">{children}</Component>;
};
